import { CustomButton } from '../../../../components/CustomButton';
import { Spacer } from '../../../../components/Spacer';

export function Footer({
  montagem,
  close,
  editarMontagem,
  cadastrarMontagem,
  handleOpenDelete,
}) {
  return (
    <>
      {Boolean(montagem?.Id) && (
        <CustomButton appearance="subtle" onClick={handleOpenDelete}>
          Apagar
        </CustomButton>
      )}
      <Spacer flex={1} />
      <CustomButton
        onClick={montagem !== null ? editarMontagem : cadastrarMontagem}
        appearance="primary"
      >
        {montagem !== null ? 'Alterar' : 'Cadastrar'}
      </CustomButton>
      <CustomButton onClick={close} appearance="ghost">
        Fechar
      </CustomButton>
    </>
  );
}
